var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReward(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 3.09C15.81 3.09 18.91 6.19 18.91 10C18.91 13.81 15.81 16.91 12 16.91C8.19 16.91 5.09 13.81 5.09 10C5.09 6.19 8.19 3.09 12 3.09ZM12 1.5C7.31 1.5 3.5 5.31 3.5 10C3.5 14.69 7.31 18.5 12 18.5C16.69 18.5 20.5 14.69 20.5 10C20.5 5.31 16.69 1.5 12 1.5Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 5.5C14.48 5.5 16.5 7.52 16.5 10C16.5 12.48 14.48 14.5 12 14.5C9.52 14.5 7.5 12.48 7.5 10C7.5 7.52 9.52 5.5 12 5.5ZM12 4C8.69 4 6 6.69 6 10C6 13.31 8.69 16 12 16C15.31 16 18 13.31 18 10C18 6.69 15.31 4 12 4Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 18.8201V21.5201L12.45 20.5701C12.3 20.5201 12.15 20.5001 12 20.5001C11.85 20.5001 11.7 20.5201 11.55 20.5701L8.5 21.5201V18.8201C7.97 18.6101 7.47 18.3501 7 18.0601V22.2001C7 22.7701 7.47 23.2001 8 23.2001C8.1 23.2001 8.2 23.1901 8.3 23.1501L12 22.0001L15.7 23.1501C15.8 23.1801 15.9 23.2001 16 23.2001C16.53 23.2001 17 22.7701 17 22.2001V18.0601C16.53 18.3601 16.03 18.6101 15.5 18.8201Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReward);
export default __webpack_public_path__ + "static/media/Reward.f22776bd.svg";
export { ForwardRef as ReactComponent };